<template>
  <div class="auth-page">
    <div class="page-toolbar">
      <div class="toolbar-left">
        <a-select v-model="query.status" allow-clear placeholder="全部状态" style="width:150px;" @change="loadData">
          <a-select-option :value="0">待审核</a-select-option>
          <a-select-option :value="1">已通过</a-select-option>
          <a-select-option :value="2">已驳回</a-select-option>
        </a-select>
      </div>
      <div class="toolbar-right">
        <a-button icon="reload" @click="loadData">刷新</a-button>
      </div>
    </div>

    <a-table :columns="columns" :data-source="data" rowKey="id" :loading="loading"
      :pagination="pagination" @change="handleTableChange" size="middle">
      <span slot="team" slot-scope="text, record">{{ record.teamName || '—' }}</span>
      <span slot="oldLeader" slot-scope="text, record">
        <div class="cell-name">{{ record.oldLeaderName || '—' }}</div>
        <div class="cell-sub">{{ record.oldLeaderMobile || '' }}</div>
      </span>
      <span slot="newLeader" slot-scope="text, record">
        <div class="cell-name">{{ record.newLeaderName || '—' }}</div>
        <div class="cell-sub">{{ record.newLeaderMobile || '' }}</div>
      </span>
      <span slot="time" slot-scope="text, record">{{ record.createTime || '—' }}</span>
      <span slot="status" slot-scope="text, record">
        <a-tag v-if="record.status === 0" color="orange">待审核</a-tag>
        <a-tag v-else-if="record.status === 1" color="green">已通过</a-tag>
        <a-tag v-else color="red" :title="record.rejectReason">已驳回</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <template v-if="record.status === 0">
          <a-popconfirm title="通过后领队身份将立即转移给接收者，确认通过？" @confirm="review(record, true)">
            <a style="color:#52C41A;">通过</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a-popconfirm title="驳回该领队移交申请？" @confirm="review(record, false)">
            <a>驳回</a>
          </a-popconfirm>
        </template>
        <span v-else style="color:#bbb;">已处理</span>
      </span>
    </a-table>
  </div>
</template>

<script>
import { getLeaderTransfers, reviewLeaderTransfer } from '@/api'

export default {
    name: 'LeaderTransferReview',
    data() {
        return {
            data: [],
            total: 0,
            loading: false,
            query: { page: 1, size: 20, status: 0 },
            pagination: { current: 1, pageSize: 20, showSizeChanger: true, showTotal: t => `共 ${t} 条` },
            columns: [
                { title: '俱乐部', dataIndex: 'team', scopedSlots: { customRender: 'team' }, width: 200 },
                { title: '原领队', dataIndex: 'oldLeader', scopedSlots: { customRender: 'oldLeader' }, width: 170 },
                { title: '接收者', dataIndex: 'newLeader', scopedSlots: { customRender: 'newLeader' }, width: 170 },
                { title: '申请时间', dataIndex: 'time', scopedSlots: { customRender: 'time' }, width: 170 },
                { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 100 },
                { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 150 }
            ]
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.loading = true
            getLeaderTransfers({ ...this.query }).then(res => {
                const data = res.data || {}
                this.data = data.list || []
                this.total = data.total || 0
            }).finally(() => { this.loading = false })
        },
        handleTableChange(pagination) {
            this.query.page = pagination.current
            this.query.size = pagination.pageSize
            this.pagination = pagination
            this.loadData()
        },
        review(record, pass) {
            reviewLeaderTransfer({ transferId: record.id, pass }).then(res => {
                this.$message.success(res.msg || (pass ? '已通过' : '已驳回'))
                this.loadData()
            }).catch(err => {
                this.$message.error((err && err.msg) || '操作失败')
                this.loadData()
            })
        }
    }
}
</script>

<style scoped>
.cell-name {
    font-weight: 600;
}
.cell-sub {
    font-size: 12px;
    color: #999;
}
</style>
